import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div({
    display: "inline-flex",
    alignItems: "baseline",
    marginTop: 4,
    width: "100%",
    padding: "0 4px",

    ":first-of-type": {
        marginTop: 0,
    },
});

export const Content = styled.div({
    flex: "1 1 100%",
});

export const ReadOnlyContent = styled.div({
    display: "flex",
    justifyContent: "space-around",
});

export const IconContainer = styled.span(props => ({
    flex: "0 0 26px",
    width: 26,
    boxSizing: "border-box",

    color: theme(props).icons.color,
    display: "inline-block",
    textAlign: "center",
    cursor: "pointer",
    paddingRight: 4,

    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));

export const ChildSpacer = styled.span({
    display: "inline-block",
    width: 5,
});
